import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from '@heroui/react';
import { useAuth } from '@/contexts/AuthContext';

export const isPopupBrowser = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent.toLowerCase();
  // Detect Arc browser
  if (ua.includes('arc')) return true;

  // Add other browsers if needed
  // e.g., Safari or mobile browsers that block redirects in new tabs
  return false;
};

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    loginWithRedirect,
    loginWithPopup,
    isLoading: auth0Loading,
    isAuthenticated: auth0Authenticated,
  } = useAuth0();
  const [isLoading, setIsLoading] = useState(true);
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const auth0Connection = import.meta.env.AUTH0_MICROSOFT_CONNECTION || '';
  useEffect(() => {
    // If user is already authenticated, redirect to stored return path or home
    if (isAuthenticated && !authLoading) {
      const returnPath = sessionStorage.getItem('returnPath') || '/';
      sessionStorage.removeItem('returnPath');
      navigate(returnPath);
    } else if (!auth0Authenticated && !auth0Loading) {
      setIsLoading(true);
      loginWithRedirect({
        authorizationParams: {
          connection: auth0Connection, // Microsoft connection
        },
      });
    }
  }, [isAuthenticated, authLoading, navigate, loginWithRedirect, auth0Connection]);

  if (auth0Loading || authLoading || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Spinner size="lg" />
      </div>
    );
  }

  if (isAuthenticated) {
    return null; // Will redirect via useEffect
  }
  return null;
};

export default LoginPage;
